import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { confirmationAccept, confirmationDeny } from 'signoxe/actions';
import { Box } from 'signoxe/components/layout';
import { Button, Popup } from 'signoxe/components/widgets';
import { getConfirmationState } from 'signoxe/selectors';
import './styles.scss';

class ConfirmationPopup extends React.Component {
  static propTypes = {
    confirmationState: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
      visible: PropTypes.bool.isRequired,
      operation: PropTypes.string,
      resourceType: PropTypes.string,
      id: PropTypes.number

    }).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  handleCancel = () => this.props.onCancel();

  handleConfirm = () => {
    const { operation, resourceType, id } = this.props.confirmationState;

    this.props.onConfirm(operation, resourceType, id);
  }

  render() {
    const { message, title, visible } = this.props.confirmationState;

    if (visible) {
      return (
        <Popup className="confirmation-popup"
          onCancel={this.handleCancel}
          title={title}
          modal>
          <Box direction="column" justifyContent="center">
            <p>{message}</p>
            <Box direction="row" className="actions button-group">
              <Button className="alert" onClick={this.handleConfirm}>OK</Button>
              <Button secondary onClick={this.handleCancel}>Cancel</Button>
            </Box>
          </Box>
        </Popup>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({ confirmationState: getConfirmationState(state) });

export default connect(mapStateToProps, {
  onConfirm: confirmationAccept,
  onCancel: confirmationDeny,
})(ConfirmationPopup);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ConfirmationPopup/index.js